export enum DividerVariant {
  LIGHT = 'light',
  DARK = 'dark',
  PRIMARY = 'primary',
}

export enum DividerDirection {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
